import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=f4f4df9e&scoped=true&"
import script from "./order-item.vue?vue&type=script&lang=js&"
export * from "./order-item.vue?vue&type=script&lang=js&"
import style0 from "./order-item.vue?vue&type=style&index=0&id=f4f4df9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f4df9e",
  null
  
)

export default component.exports